<div class="modal-content">
  <div class="modal-header">
      <h4 class="modal-title">{{ 'control.products.bulkEdit.title'  | translate }}</h4>
      <button type="button" class="close" aria-label="Close" (click)="close()">
      <span aria-hidden="true">&times;</span>
      </button>
  </div>
  <div class="modal-body">
      <div *ngIf="alertMain" class="mb-2">
          <app-alert [alertSettings]="alertMain"></app-alert>
      </div>
      <div class="alert alert-warning">
          <fa-icon class="me-2" [icon]="faExclamationTriangle"></fa-icon><b>{{ 'control.products.bulkEdit.warning' | translate }}</b> {{ 'control.products.bulkEdit.message' | translate }}
      </div>
      <select class="form-control" [formControl]="bulkAction" (change)="actionChanged()">
          <option [ngValue]="null">{{ 'control.products.bulkEdit.selectAction' | translate }}</option>
          <option *ngFor="let action of actionList" [ngValue]="action">
              {{action.itemName}}
          </option>
      </select>
      <form *ngIf="actionForm" [formGroup]="actionForm">
        <ng-container *ngIf="bulkAction.value && bulkAction.value.id === 1 && !loadingVat">
          <div class="form-group mt-2">
            <select class="form-control" formControlName="vatRate">
              <option [ngValue]="null">
              </option>
              <option *ngFor="let vat of vatList" [ngValue]="vat">
                  {{vat.percentage}}% ({{vat.name}})
              </option>
            </select>
          </div>
        </ng-container>

        <ng-container *ngIf="bulkAction.value && bulkAction.value.id === 2">
          <div class="form-group mt-2">
            <div class="title">{{ 'control.products.edit.sellOnPos' | translate }}</div>
            <div class="form-check form-switch">
                <input id="sellOnPos" type="checkbox" class="form-check-input" formControlName="sellOnPos" />
                <label class="form-check-label" for="sellOnPos">{{ 'control.products.edit.sellOnPosAllowed' | translate }}</label>
            </div>
            <div class="form-check form-switch">
                <input id="priceOverride" type="checkbox" class="form-check-input" formControlName="priceOverride" />
                <label class="form-check-label" for="priceOverride">{{ 'control.products.edit.priceOverride' | translate }}</label>
            </div>
            <div class="form-check form-switch">
                <input id="promptForUnit" type="checkbox" class="form-check-input" formControlName="promptForUnit" />
                <label class="form-check-label" for="promptForUnit">{{ 'control.products.edit.promptForUnit' | translate }}</label>
            </div>
            <div class="form-check form-switch">
                <input id="promptForPrice" type="checkbox" class="form-check-input" formControlName="promptForPrice" />
                <label class="form-check-label" for="promptForPrice">{{ 'control.products.edit.promptForPrice' | translate }}</label>
            </div>
            <div class="form-check form-switch">
                <input id="promptForAgeVerification" type="checkbox" class="form-check-input" formControlName="promptForAgeVerification" />
                <label class="form-check-label" for="promptForAgeVerification">{{ 'control.products.edit.requireAgeVerification' | translate }}</label>
            </div>
            <div class="form-check form-switch">
                <input id="excludeFromReceipt" type="checkbox" class="form-check-input" formControlName="excludeFromReceipt" />
                <label class="form-check-label" for="excludeFromReceipt">{{ 'control.products.edit.notOnCustBill' | translate }}</label>
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="bulkAction.value && bulkAction.value.id === 3">
          <div class="form-group mt-2">
            <div *ngIf="!loadingRoutingTags && routingTagItemList.length">
                <angular2-multiselect
                    [data]="routingTagItemList"
                    formControlName="selectedRoutingTags"
                    [settings]="routingTagListSettings"
                    (onSelect)="onItemSelect($event, 'selectedRoutingTags')"
                    (onDeSelectAll)="onDeSelectAll($event, 'selectedRoutingTags')">
                </angular2-multiselect>
              </div>
          </div>
        </ng-container>

      </form>
  </div>
  <div class="modal-footer">
      <button type="button" class="btn btn-outline-dark" [disabled]="loadingAction" (click)="close()">{{ 'shared.closeBtn' | translate }}</button>
      <button type="button" class="btn btn-primary" [disabled]="loadingAction || (actionForm && actionForm.invalid) || bulkAction.invalid" (click)="runAction()">
          <ng-container *ngIf="loadingAction">
              {{ 'shared.saving' | translate }}
          </ng-container>
          <ng-container *ngIf="!loadingAction">
              {{  'shared.saveBtn' | translate }}
          </ng-container>
      </button>
  </div>
</div>
